import Layout from "../components/Layout";

function Rechner() {
  return (
    <Layout>
      <h1>Rechner</h1>
    </Layout>
  );
}

export default Rechner;